import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8010";

const instance = axios.create({ baseURL });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("xtm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    const isAuthRoute = url.includes("/auth/");
    if (error.response?.status === 401 && !isAuthRoute) {
      localStorage.removeItem("xtm_token");
      window.location.hash = "#/sign-in";
    }
    return Promise.reject(error);
  }
);

export default instance;
